module.exports = __webpack_public_path__ + "img/ipad-cn-5.22f96e7.jpg";